export enum LocalStorageKeys {
    appLang = "app-lang",
    user = "user",
    studentsQueryKey = "students-query-key",
}
